/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-props-no-spreading */
/**
 * @author Shalini Jha
 * @name Tooltip
 * @desc This component is a custom tooltip that is used for Quick Tour
 */

import React from 'react';
import clsx from 'clsx';
import styles from './Tooltip.module.css';
export const renderCarouselSteps = (allSteps, active) =>
    allSteps.map((item, index) => (
        <div
            key={item.title}
            className={clsx(styles.carouselLegend, index === active ? styles.carouselLegendActive : null)}
        />
    ));
const Tooltip = ({ continuous, index, step, backProps, primaryProps, tooltipProps, allSteps }) => (
    <div className={styles.tooltipBody} {...tooltipProps} id="tooltipbody">
        {step.title && <div className={styles.tooltipHeader}>{step.title}</div>}
        <div className={styles.tooltipContent}>
            {step.content}
            <div>
                {step.points && step.points.length > 0 && (
                    <ul>
                        {step.points.map((pointObj, id) => {
                            return (
                                <li>
                                    <b>{Object.keys(pointObj)}</b>:{Object.values(pointObj)}
                                </li>
                            );
                        })}
                    </ul>
                )}
            </div>
        </div>
        <div className={styles.tooltipFooter}>
            {index > 0 && (
                <span {...backProps} className={`sct-icon icon-Back-Arrow-181x ${styles.tooltipBackArrow}`} />
            )}
            {index === 0 && continuous && (
                <span className={`sct-icon icon-Back-Arrow-181x ${styles.tooltipBackArrowDisabled}`} />
            )}
            <div className={styles.carouselLegendContainer}>{renderCarouselSteps(allSteps, index)}</div>
            {continuous && <span {...primaryProps} className={`sct-icon icon-Arrow-181x ${styles.tooltipNextArrow}`} />}
        </div>
    </div>
);
export default Tooltip;
